import type { RecursiveReadonly } from "@p0security/util/types/util";
import { size } from "lodash-es";

import { installedItems } from "../../install/installed.ts";
import type { IntegrationConfig } from "../../integrations/shared.ts";
import type {
  ApprovalRule,
  Directory,
  DurationLimitedApproval,
  RequestorRule,
  ResourceRule,
} from "./types.ts";

export const ruleComponents = ["resource", "requestor", "approval"] as const;

export const headingsFromComponentType: Record<
  (typeof ruleComponents)[number],
  string
> = {
  resource: "Resource",
  requestor: "Requestor",
  approval: "Actions",
};

export const directoryInfo: RecursiveReadonly<
  Record<
    Directory,
    { label: string; isInstalled: (config: IntegrationConfig) => boolean }
  >
> = {
  "azure-ad": {
    label: "Entra ID (Legacy)",
    isInstalled: (config: IntegrationConfig) =>
      config.state === "installed" ||
      !!size(installedItems("iam-write", config as any)),
  },
  "entra-id": {
    label: "Entra ID",
    isInstalled: (config: IntegrationConfig) =>
      config.state === "installed" ||
      !!size(installedItems("iam-write", config as any)),
  },
  okta: {
    label: "Okta",
    isInstalled: (config: IntegrationConfig) =>
      !!size(installedItems("listing", config as any)),
  },
  workspace: {
    label: "Google Workspace",
    isInstalled: (config: IntegrationConfig) => config.state === "installed",
  },
};

// We're having to do this backwards.
// Because ts-schema-generator doesn't allow for generics or derived types,
// we have to create constant mappings from the types we want to use.
// These constants are used to require type exhaustiveness if we add a new
// resource type, requestor type, or access type.
export const resourceTypes: Readonly<Record<ResourceRule["type"], boolean>> = {
  any: true,
  integration: true,
};

export const requestorTypes: Readonly<Record<RequestorRule["type"], boolean>> =
  {
    agentic: true,
    any: true,
    group: true,
    user: true,
  };

export const accessTypes: Readonly<Record<ApprovalRule["type"], boolean>> = {
  group: true,
  "requestor-profile": true,
  auto: true,
  escalation: true,
  p0: true,
  deny: true,
  persistent: true,
};

export const NO_APPROVALS: DurationLimitedApproval[] = [];
